import store from "../store";

export default async (to, from, next) => {
  if (to.name != from.name) window.scrollTo(0, 0);

  const requiredAuth = to.meta.authRequired ?? false;
  const preventAuth = to.meta.preventAuth ?? false;

  const authenticated = !!store.getters.token;

  if (requiredAuth && !authenticated) return next("/connect");
  if (preventAuth && !authenticated) return next("/connect");

  document.title = to.name + "- Pitch Connect";

  next();
};
